import React, {  useState,  } from "react";
import {  message,  } from "antd";
import { useNavigate } from "react-router-dom";
import Header from "../Header/Header";
import userServiceInstance from "../../APIs/users";
import Footer from "../Footer/Footer";
import SignupForm from "./SinupForm";
import { useLoadScript } from "@react-google-maps/api";
import { useNotification } from "../Toast/Notification";
const Signup = () => {
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: "AIzaSyB1rIsa_A5keNvPCSqAzVsY92LgLRmfTmI",
    libraries: ["places"],
  });


  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [firstName, setFirstName] = useState<string>("");
  const [lastName, setLastName] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");


  const [phone_number, setPhoneNumber] = useState<number>(0);


  const { notify } = useNotification();

  const onFinish = async () => {
    setLoading(true);

    try {
      const emailExists = await userServiceInstance.getUserByEmailAddress(
        email
      );

      if (emailExists.data) {
        message.error(
          "Email already exists. Please use a different email address."
        );
        return;
      }

     
      const data = {
        firstName,
        lastName,
        email,
        password,
        role: "client",
        is_verified: false,
        phone_number: phone_number,
      };

      const responseData = await userServiceInstance.createUser(data);
      if (responseData.error) {
        const errorMessage = responseData.error.includes("500")
          ? "An unexpected server error occurred. Please try again."
          : `Sign-up failed: ${responseData.error}`;
        message.error(errorMessage);
      } else {
        if (responseData.data) {
          notify(
            "Account created successfully! Please check your email to verify your account.",
            "success"
          );
          navigate("/confirmation");
        } else {
          notify("User creation was unsuccessful, please try again", "error");
        }
      }
    } catch (error) {
      notify("An unexpected error occurred. Please try again.", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Header
        title="CREATE AN ACCOUNT"
        textBackground="SIGN UP"
        backgroundImg="http://res.cloudinary.com/brabenjos/image/upload/v1729584914/sodastream/1729584914532.png"
        subTitle=""
        desktopHeight="100vh"
        
      />

      <SignupForm
        firstName={firstName}
        lastName={lastName}
        email={email}
        password={password}
        onFinish={onFinish}
        setFirstName={setFirstName}
        setLastName={setLastName}
        setEmail={setEmail}
        setPassword={setPassword}
        loading={loading}
        phone_number={phone_number}
        setPhoneNumber={setPhoneNumber}
      />

      <Footer />
    </>
  );
};

export default Signup;
